<div class="image-picker-dialog-container" data-cy="imagepicker-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="imagepicker-header-section">
      <div class="section-header-title" data-cy="imagepicker-title-text">
        Choose Image
      </div>
      <div style="flex: 1;"></div>
    </div>
    <div class="section-content" style="flex: 1; text-align: center; margin-top: 12px;" data-cy="imagepicker-content-section">
      <div style="flex: 1; height: 440px; overflow-y: auto; overflow-x: auto;" #gridContainer data-cy="imagepicker-grid-container">
        <app-tdo-image-grid [ngClass]="{'col-lg-3 bg-secondary': isShowPublish, 'col-lg-12': !isShowPublish}"
                            style="height: 100%; width: 100%; overflow-x: hidden; display: flex; flex-wrap:wrap; overflow-wrap: break-word" #tdoImageGrid
                            [isZoomEnabled]="false"
                            [isDragEnabled]="false"
                            [isExternalDragEnabled]="false"
                            [gridContainer]="gridContainer"
                            [dataSet]="thumbnailImages"
                            [isDocumentManagerMode]="true"
                            [boxWidth]="thumbnailImageSize"
                            (itemsSelected)="onGridItemsSelected($event)"
                            (contextOpened)="onGridContextMenu($event)"
                            (backgroundContextOpen)="onGridBackgroundContextMenu($event)"
                            [imageLabels]="this.descriptions"
                            [disabledIDs]="this.disabledIDs"
                            [checkedIDsClaimAttachmentAdded]="this.checkedIDsAdded"
                            [checkedIDsClaimAttachmentSent]="this.checkedIDsSent"
                            data-cy="imagepicker-image-grid">

        </app-tdo-image-grid>
      </div>


    </div>
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="imagepicker-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="imagepicker-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="imagepicker-ok-button">Ok</button>
    </div>
  </div>
</div>
